// FAQ « Poser ma question » (snippets/snk-faq-ask) : le bouton déroule le formulaire sur place (hauteur animée en CSS,
// 320 ms comme les accordéons), l'envoi part en arrière-plan vers le formulaire contact natif Shopify (/contact) :
// la page ne change pas. Succès : Shopify redirige vers ?contact_posted=true. Vérification anti-robot : redirection
// vers /challenge, on le dit et on propose l'envoi classique dans un nouvel onglet. Erreur : message, texte conservé.
if (!customElements.get('snk-faq-ask')) {
  customElements.define(
    'snk-faq-ask',
    class SnkFaqAsk extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-snk-ask-toggle]');
        this.panel = this.querySelector('[data-snk-ask-panel]');
        this.form = this.querySelector('[data-snk-ask-form]');
        this.status = this.querySelector('[data-snk-ask-status]');
        this.done = this.querySelector('[data-snk-ask-done]');
        if (!this.toggle || !this.panel || !this.form) return;
        this.toggle.addEventListener('click', () => this.setOpen(this.toggle.getAttribute('aria-expanded') !== 'true'));
        this.form.addEventListener('submit', (event) => this.submit(event));
      }

      setOpen(open) {
        this.toggle.setAttribute('aria-expanded', String(open));
        this.panel.classList.toggle('is-open', open);
        this.panel.inert = !open;
        if (open) {
          const first = this.form.hidden ? this.done : this.form.querySelector('input:not([type="hidden"])');
          setTimeout(() => first?.focus({ preventScroll: true }), 120);
        }
      }

      // Taille choisie au moment de l'envoi (sélecteur de taille de la fiche), rien si la fiche n'en a pas
      currentSize() {
        const select = document.querySelector('product-info.snk-product [data-snk-size-native]');
        return select?.value || '';
      }

      say(message, extra) {
        this.status.textContent = message;
        if (extra) this.status.append(' ', extra);
        this.status.hidden = !message;
      }

      async submit(event) {
        event.preventDefault();
        if (this.busy) return;
        if (!this.form.checkValidity()) {
          this.say(this.dataset.invalid);
          this.form.querySelector(':invalid')?.focus();
          return;
        }
        const sizeInput = this.form.querySelector('[data-snk-ask-size]');
        if (sizeInput) {
          sizeInput.value = this.currentSize();
          sizeInput.disabled = !sizeInput.value;
        }
        this.busy = true;
        this.form.setAttribute('aria-busy', 'true');
        this.say(this.dataset.sending);
        let outcome = 'error';
        try {
          const response = await fetch(this.form.action, {
            method: 'POST',
            body: new FormData(this.form),
            credentials: 'same-origin',
            headers: { Accept: 'text/html' },
          });
          const url = response.url || '';
          if (/\/challenge/.test(url)) outcome = 'captcha';
          else if (response.ok && /contact_posted=true/.test(url)) outcome = 'success';
        } catch (error) {
          outcome = 'error';
        }
        this.busy = false;
        this.form.removeAttribute('aria-busy');

        if (outcome === 'success') {
          this.say('');
          this.form.reset();
          this.form.hidden = true;
          this.done.hidden = false;
          this.done.focus({ preventScroll: true });
        } else if (outcome === 'captcha') {
          // Repli : même formulaire envoyé de façon classique dans un nouvel onglet, le texte saisi reste ici
          const fallback = document.createElement('button');
          fallback.type = 'button';
          fallback.className = 'snk-faq-ask__fallback';
          fallback.textContent = this.dataset.captchaAction || '→';
          fallback.addEventListener('click', () => {
            this.form.target = '_blank';
            HTMLFormElement.prototype.submit.call(this.form);
            this.form.removeAttribute('target');
          });
          this.say(this.dataset.captcha, fallback);
        } else {
          this.say(this.dataset.error);
        }
      }
    }
  );
}
